import { Reducer } from "react";
import { ActionTypes, Actions } from "../actions/common";
import { Meeting } from "../models"

export const selectedListReducer: Reducer<Meeting | undefined, Actions> = (state: Meeting | undefined, action: Actions) => {
    switch (action.type) {
        case ActionTypes.SELECT_LIST:
        case ActionTypes.LOAD_LIST:
            state = action.payload ? { ...action.payload } : undefined;
            break;
        case ActionTypes.DELETE_LIST:
            if (state && state.id === action.payload) {
                state = undefined;
            }
            break;
        case ActionTypes.LOAD_ITEMS:
            if (state) {
                state.items = [...action.payload];
            }
            break;
        case ActionTypes.SAVE_ITEM:
            if (state) {
                const items = [...(state.items || [])];
                const index = items.findIndex(item => item?.id === action.payload?.id);
                if (index > -1) {
                    items.splice(index, 1, action.payload);
                    state.items = items;
                } else {
                    state.items = [...items, action.payload];
                }
            }
            break;
        case ActionTypes.SAVE_LIST:
            if (action.payload.id === state?.id) {
                state = { ...action.payload };
            }
            break;
        case ActionTypes.DELETE_ITEM:
            if (state) {
                state.items = [...(state.items || []).filter(item => item.id !== action.payload)];
            }
            break;
    }

    return state;
}